import { useContext, useMemo } from 'react';
import { RegistrationStore, BrandStore } from '../context';
import { arePaymentsFieldsHidden } from '../pages/payments/PaymentsFields.util';
import { areBusinessFieldsHidden } from '../pages/business/BusinessFields.util';
import { areFinancialFieldsHidden } from '../pages/financial/FinancialFields.util';

export function useAreAllFieldsHidden(
  page: 'Business' | 'Payments' | 'Business Owner/Financial',
) {
  const {
    state: { brand },
  } = useContext(BrandStore);

  const {
    state: { registration },
  } = useContext(RegistrationStore);

  return useMemo(() => {
    switch (page) {
      case 'Payments':
        return arePaymentsFieldsHidden(brand, registration);
      case 'Business':
        return areBusinessFieldsHidden(brand, registration);
      case 'Business Owner/Financial':
        return areFinancialFieldsHidden(brand, registration);
      default:
        return false;
    }
  }, [brand, registration, page]);
}
